import React, { useState, useContext } from 'react';
import UserDetailsContext from '../context/userDetails.context';
import LocationsContext from '../context/locations.Context';
import ThemeContext from '../context/theme.Context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';
import ChangePasswordDialog from './ChangePasswordDialog';
import ChangeEmailDialog from './ChangeEmailDialog';

import logoBlack from '../images/logo-black.svg';
import logoWhite from '../images/logo-white.svg';


const UserProfile = () => {

    const { userName, email, setUserDetails } = useContext(UserDetailsContext);
    const { clearLocationsData } = useContext(LocationsContext);

    const [showPasswordDialog, setShowPasswordDialog] = useState(false);
    const [showEmailDialog, setShowEmailDialog] = useState(false);

    function logout() {
        setUserDetails({ userId: '', userName: '', email: '', userLocations: [], token: '' });
        clearLocationsData();
    }

    function changePassword() {
        setShowPasswordDialog(!showPasswordDialog);
    }

    function changeEmail() {
        setShowEmailDialog(!showEmailDialog);
    }

    function setTheme(themeContext) {
        if (themeContext.theme === 'dark') {
            themeContext.setTheme('light');
        }
        else {
            themeContext.setTheme('dark');
        }
    }
    return (
        <ThemeContext.Consumer>
            {(themeContext) => (
                <Card bg={themeContext.theme} text={themeContext.textColor}>
                    <Card.Body>
                        <Card.Title>
                            {themeContext.logo === 'logo-black.svg' &&
                                <img src={logoBlack} height="45px" alt="logo" />
                            }
                            {themeContext.logo !== 'logo-black.svg' &&
                                <img src={logoWhite} height="45px" alt="logo" />
                            }
                            <div>User profile</div>
                        </Card.Title>
                        <Card.Text as="div">
                            <Table variant={themeContext.theme}>
                                <tbody>
                                    <tr>
                                        <td width='150em'>Username</td>
                                        <td>{userName}</td>
                                    </tr>
                                    <tr>
                                        <td>Email</td>
                                        <td>{email}</td>
                                    </tr>
                                    <tr>
                                        <td>Theme</td>
                                        <td>
                                            <Button variant={themeContext.theme} onClick={() => {
                                                setTheme(themeContext);
                                            }}
                                            >
                                                { themeContext.theme === 'dark' &&
                                                    <FontAwesomeIcon icon="toggle-on" />
                                                }
                                                { themeContext.theme !== 'dark' &&
                                                    <FontAwesomeIcon icon="toggle-off" />
                                                }
                                            </Button>
                                            {themeContext.theme}
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>

                            <Button variant="secondary" style={{ marginRight: '10px' }} title='Change password' onClick={() => changePassword()}><FontAwesomeIcon icon="key" /></Button>
                            <Button variant="secondary" style={{ marginRight: '10px' }} title='Change email' onClick={() => changeEmail()}><FontAwesomeIcon icon="envelope" /></Button>
                            <Button variant="secondary" title='Logout' onClick={() => logout()}><FontAwesomeIcon icon="sign-out-alt" /></Button>

                            <ChangePasswordDialog show={showPasswordDialog} onHide={() => setShowPasswordDialog(false)} />
                            <ChangeEmailDialog show={showEmailDialog} onHide={() => setShowEmailDialog(false)} />

                        </Card.Text>

                    </Card.Body>

                </Card>
            )}
        </ThemeContext.Consumer>
    );
};

export default UserProfile;


// WEBPACK FOOTER //
// ./src/components/UserProfile.js